import { useTernaryDarkMode } from "usehooks-ts"
import { useAuthStore } from "@/store/auth"
import { NavLink } from "react-router-dom"
import logoWhite from "/logo-white.svg"
import logoDark from "/logo-dark.svg"
import React, { FC } from "react"
import { Col } from "antd"
import { getStaffToken, isStaffAdminHost, signInPath } from "@/adminHost"
import "./index.less"

interface LogoProps {
  forceDark?: boolean
}

const Logo: FC<LogoProps> = ({ forceDark = false }) => {
  const userLoggedIn = useAuthStore(store => store.loggedIn)
  const { isDarkMode } = useTernaryDarkMode({ localStorageKey: "theme" })
  const homeTo = isStaffAdminHost()
    ? (getStaffToken() ? "/admin" : signInPath())
    : (userLoggedIn ? "/dashboard" : "/sign-in")

  // If forceDark is true, always use dark logo, otherwise use theme-based logic
  const logoSrc = forceDark ? logoDark : (!isDarkMode ? logoDark : logoWhite)

  return (
    <Col className={"aside-logo"}>
      <NavLink to={homeTo}>
        <img src={logoSrc} />
      </NavLink>
    </Col>
  )
}

export default Logo
